import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    const [hours, minutes] = value.split(':');
    let hours24 = parseInt(hours);
    let period = 'AM';

    if (hours24 >= 12) {
      period = 'PM';
      if (hours24 > 12) {
        hours24 -= 12;
      }
    } else if (hours24 === 0) {
      hours24 = 12;
    }

    return `${hours24}:${minutes} ${period}`;
  }

}
